import { useMemo } from 'react';

import { ViewType } from '@this+that/models';

import { useInboxTabsConfig } from '../../../components/InboxSettings/hooks/useInboxTabsConfig';
import { InboxTab } from '../../../components/InboxSettings/types/types';
import { VIEW_TYPES } from '../../../enums/viewTypes';

const INBOX_TAB_TO_VIEW_TYPE: Record<InboxTab, ViewType> = {
  [InboxTab.PRIMARY]: InboxTab.PRIMARY,
  [InboxTab.PROMOTIONS]: InboxTab.PROMOTIONS,
  [InboxTab.SOCIAL]: InboxTab.SOCIAL,
  [InboxTab.UPDATES]: InboxTab.UPDATES,
  [InboxTab.FORUMS]: InboxTab.FORUMS,
};

const NON_CATEGORY_VIEW_TYPES: ViewType[] = [
  VIEW_TYPES.SENT,
  VIEW_TYPES.SPAM,
  VIEW_TYPES.DRAFT,
  VIEW_TYPES.TRASH,
];

export function useInboxFetchGroups() {
  const { selectedTabs } = useInboxTabsConfig();

  const combinedViewTypes = useMemo<ViewType[]>(() => {
    const disabledNonPrimaryViewTypes = selectedTabs
      .filter((t) => t.tab !== InboxTab.PRIMARY && !t.enabled)
      .map((t) => INBOX_TAB_TO_VIEW_TYPE[t.tab]);

    return [InboxTab.PRIMARY, ...disabledNonPrimaryViewTypes];
  }, [selectedTabs]);

  const separateViewTypes = useMemo<ViewType[]>(() => {
    return selectedTabs
      .filter((t) => t.tab !== InboxTab.PRIMARY && t.enabled)
      .map((t) => INBOX_TAB_TO_VIEW_TYPE[t.tab]);
  }, [selectedTabs]);

  const nonCategoryViewTypes = useMemo<ViewType[]>(
    () => NON_CATEGORY_VIEW_TYPES,
    [],
  );

  return { combinedViewTypes, separateViewTypes, nonCategoryViewTypes };
}
